/**
 * mobile 申請成功提示頁面
 */
/* eslint-disable react/jsx-max-depth */
import React, { useRef } from 'react';
import { useIntl, useLocation } from 'umi';
import { usePersistFn } from 'ahooks';
import { Divider } from 'antd';
import { Modal } from 'antd-mobile';
import { MoBaseContainer as BaseContainer } from '@gov-mo/components';
import HandleButton from '@/components/HandleButton';
import submitSuccessImg from '@/assets/submit-success.png';
import submitErrorImg from '@/assets/submit-fail.png';
import { Page } from '@gov-mo/mpaas-js-bridge';
import queryString from 'query-string';
import { CloseOutlined } from '@ant-design/icons';
import styles from './MobileComplete.less';
import { openPageRelativePath } from '@/utils';
import { removeToken } from '@/utils/apiUtils';

export default function MobileComplete() {
  const intl = useIntl();
  // const { workNo } = useSelector(({ stepModels }: { stepModels: StepModelsState }) => stepModels);
  const location = useLocation();
  // 从URL查询参数获取workNo
  const urlParams = queryString.parse(location.search);
  const status = urlParams.status || ''; // 提供默认值
  const msg = urlParams.msg || ''; // 提供默认值
  const submitTime = urlParams.submitTime || ''; // 提供默认值

  const getMsg = (msg: Array<string | null> | null | string): string => {
    // 如果取消状态为1，直接显示已取消
    switch (msg) {
      case 'exist':
        return intl.formatMessage({ id: '在評估未完成之前，不可新增申請。' });
      default:
        return intl.formatMessage({ id: '保存申請失敗！您可嘗試再次申請。' });
    }
  };
  /**
   * 退出时弹出的对话框方法
   */
  // 点击右上角"x"的时候，提示框的控制
  const goBackModal = useRef<{ close: () => void } | null>(null);

  const handleGoBackModal = usePersistFn(() => {
    if (goBackModal.current) return;
    goBackModal.current = Modal.alert(
      intl.formatMessage({ id: '温馨提示' }),
      intl.formatMessage({ id: '确认放弃当前操作，并退出' }),
      [
        {
          text: intl.formatMessage({ id: '取消' }),
          onPress: () => {
            goBackModal.current?.close();
            goBackModal.current = null;
          },
        },
        {
          text: intl.formatMessage({ id: '确认' }),
          onPress: () => {
            removeToken();
            Page.close();
          },
        },
      ],
    );
  });
  return (
    <BaseContainer
      type="custom"
      onLeftClick={() => {
        Page.close();
      }}
      titleContent="完成提交"
      rightContent={(
        <div className={styles.headerRightContent}>
          <div onClick={handleGoBackModal} className={styles.iconArea}>
            <CloseOutlined
              className={`${styles.icon} ${styles.closeIcon}`}
              role="button"
              aria-label={intl.formatMessage({ id: '關閉' })}
            />
          </div>
        </div>
      )}
    >
      <div className={styles.root}>
        <div className={styles.container}>
          {status === 'true' && (
            <>
              <img src={submitSuccessImg} alt="submit-success" className={styles.successImg} />
              <div className={styles.content}>
                <div className={styles.successWarn}>
                  {intl.formatMessage({ id: '成功提交申請' })}
                </div>
                <div className={styles.successInfoArea}>
                  <div className={styles.itemTitle}>{intl.formatMessage({ id: '申請成為寄養父母' })}</div>
                  <div className={styles.infoItem}>
                    <div className={styles.itemKey}>{intl.formatMessage({ id: '申請編號' })}</div>
                    <div className={styles.itemNumber}>{msg}</div>
                  </div>
                  <div className={styles.infoItem}>
                    <div className={styles.itemKey}>{intl.formatMessage({ id: '申請時間' })}</div>
                    <div className={styles.itemNumber}>{submitTime}</div>
                  </div>
                </div>
                <Divider className={styles.dashedDivider} />
                <div className={styles.successMsg}>
                  {intl.formatMessage({
                    id: '填寫申請資料並經過社會工作局的電話甄選後符合基本條件的夫婦，本局將透過電話邀請出席座談會。',
                  })}
                </div>
                {/* <div className={styles.successMsg}>
                  {intl.formatMessage({ id: '你可登入' })}
                  <span className={styles.greenText}>一戶通</span>
                  {intl.formatMessage({ id: '的【我的辦事】查詢本申請進度。' })}
                  <div className={px('successMsg')}>
                    {intl.formatMessage({ id: '你可登入' })}
                    <span className={px('green-text')}>{intl.formatMessage({ id: '一戶通' })}</span>
                    {intl.formatMessage({ id: '的【我的辦事】查詢本申請進度。' })}
                  </div>
                </div> */}
                <div className={styles.successMsg}>
                  {intl.formatMessage({ id: '你可登入' })}
                  <span className={styles.greenText}>{intl.formatMessage({ id: '一戶通' })}</span>
                  {intl.formatMessage({ id: '的【我的辦事】查詢本申請進度。' })}
                </div>
              </div>
            </>
          )}
          {status === 'false' && (
            <>
              <img src={submitErrorImg} alt="submit-success" className={styles.successImg} />
              <div className={styles.errorContent}>
                <div className={styles.errorWarn}>
                  {intl.formatMessage({ id: '未能成功提交' })}
                </div>
                <Divider className={styles.dashedDivider} />
                <div className={styles.successInfoArea}>
                  <div className={styles.infoItem}>
                    {getMsg(msg)}
                    <br />
                    {intl.formatMessage({ id: '如有疑問，請在社會工作局工作日致電：83997703 / 83997766。' })}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <HandleButton
          rightButton={{
            text: intl.formatMessage({ id: '完成' }),
            onClick: () => {
              // window.location.href = '/foster-apply-list?platform=personal';
              Page.close();
              openPageRelativePath('foster-apply-list');
            },
          }}
        />
      </div>
    </BaseContainer>
  );
}
